module.exports = __webpack_public_path__ + "img/chrome-icon.2ce13bcd.svg";